export function accountMobileNavUtil(state) {
    const localizations = state.core.localizations.containers.chromeLocalization;
    const currentLocation = document.location.pathname;

    let h2 = $('.js-account-nav-dropdown');

    if (currentLocation.includes('account-settings')) {
        h2.text(localizations['account_navigation-profile']);
    } else if (currentLocation.includes('address')) {
        h2.text(localizations['account_navigation-addressAndPayments']);
    } else if (currentLocation.includes('wishlist')) {
        h2.text(localizations['account_navigation-wishLists']);
    } else if (currentLocation.includes('order')) {
        h2.text(localizations['account_navigation-orderHistory']);
    } else if (currentLocation.includes('hearted-products')) {
        h2.text(localizations['account_navigation-favorites']);
    } else if (currentLocation.includes('hearted-pics')) {
        h2.text(localizations['account_navigation-fpme']);
    } else if (currentLocation.includes('rewards')) {
        h2.text(localizations['account_navigation-rewards']);
    } else {
        h2.text(localizations['account_navigation-dashboard']);
    }
}
